/* Fuego & Fragancia — comportamiento del sidecart.

   Son custom elements y no un script suelto a propósito: el JS de Dawn
   reemplaza el HTML del carrito entero en cada cambio, así que un listener
   puesto una sola vez al cargar la página se perdería. connectedCallback en
   cambio se vuelve a ejecutar cada vez que el elemento se reinserta. */

/* ---------- Reapertura tras venir de /cart ----------
   theme.liquid devuelve a la tienda a quien caiga en la página /cart (que ya
   no se usa) dejando esta marca. Aquí se recoge para que el cliente no pierda
   el hilo: vuelve a la tienda con su carrito ya abierto. */

document.addEventListener('DOMContentLoaded', () => {
  if (sessionStorage.getItem('ff-open-cart') !== '1') return;
  sessionStorage.removeItem('ff-open-cart');

  // Se espera a que el custom element esté definido para poder abrirlo.
  customElements.whenDefined('cart-drawer').then(() => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  });
});

/* ---------- Guardián del estado vacío ----------
   Red de seguridad contra el bug que rompía el carrito: la clase `is-empty`
   vive en <cart-drawer>, que NO se vuelve a pintar en las actualizaciones AJAX,
   y cada script que agrega al carrito tenía que acordarse de quitarla a mano
   (product-form.js lo hacía, ff-product.js y ff-ritual-builder.js no). Si se
   quedaba pegada, `cart-drawer.is-empty .drawer__inner{display:grid}` de Dawn
   deshacía el panel entero.

   Este elemento va DENTRO del panel, así que se reconstruye en cada render y
   deja la clase sincronizada con el estado real del carrito, venga el cambio
   de donde venga. */

if (!customElements.get('ff-cart-guard')) {
  customElements.define(
    'ff-cart-guard',
    class FfCartGuard extends HTMLElement {
      connectedCallback() {
        const drawer = this.closest('cart-drawer');
        if (!drawer) return;
        drawer.classList.toggle('is-empty', this.dataset.empty === 'true');
      }
    }
  );
}

/* ---------- Carrusel de "Complete your ritual" ---------- */

if (!customElements.get('ff-cart-recs')) {
  customElements.define(
    'ff-cart-recs',
    class FfCartRecs extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.ff-cart__recs-viewport');
        this.track = this.querySelector('.ff-cart__recs-track');
        if (!this.track || !this.viewport) return;

        this.cards = Array.from(this.track.children);
        this.count = this.cards.length;
        this.index = 0;
        this.seconds = parseFloat(this.dataset.rotate || '0');

        if (this.count < 2) return;

        this.track.classList.add('is-draggable');
        this.buildDots();
        this.enableDrag();
        this.startAuto();

        this.addEventListener('mouseenter', () => this.stopAuto());
        this.addEventListener('mouseleave', () => this.startAuto());
        this.addEventListener('focusin', () => this.stopAuto());
      }

      /* --- Puntos --- */

      buildDots() {
        this.dotsWrap = document.createElement('div');
        this.dotsWrap.className = 'ff-cart__recs-dots';

        this.dots = this.cards.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ff-cart__recs-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', `Sugerencia ${i + 1} de ${this.count}`);
          dot.addEventListener('click', () => {
            this.goTo(i);
            this.stopAuto();
          });
          this.dotsWrap.appendChild(dot);
          return dot;
        });

        this.appendChild(this.dotsWrap);
      }

      goTo(i) {
        this.index = (i + this.count) % this.count;
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        if (this.dots) {
          this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));
        }
      }

      /* --- Rotación automática --- */

      startAuto() {
        if (this.timer || !this.seconds) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.seconds * 1000);
      }

      stopAuto() {
        clearInterval(this.timer);
        this.timer = null;
      }

      /* --- Arrastre con dedo o ratón --- */

      enableDrag() {
        let startX = 0;
        let delta = 0;
        let dragging = false;
        let moved = false;

        const width = () => this.viewport.clientWidth || 1;

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          dragging = true;
          moved = false;
          startX = event.clientX;
          delta = 0;
          this.stopAuto();
        });

        this.viewport.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          delta = event.clientX - startX;

          if (!moved && Math.abs(delta) > 5) {
            moved = true;
            this.track.classList.add('is-dragging');
            // La captura se pide solo al confirmar un arrastre real: pedirla
            // en pointerdown haría que un clic simple sobre "ADD" no llegara
            // nunca al botón.
            this.viewport.setPointerCapture(event.pointerId);
          }

          if (moved) {
            const offset = -this.index * width() + delta;
            this.track.style.transform = `translateX(${offset}px)`;
          }
        });

        const end = (event) => {
          if (!dragging) return;
          dragging = false;
          this.track.classList.remove('is-dragging');

          if (this.viewport.hasPointerCapture?.(event.pointerId)) {
            this.viewport.releasePointerCapture(event.pointerId);
          }

          if (moved) {
            // Un cuarto del ancho basta para pasar de tarjeta.
            if (Math.abs(delta) > width() / 4) {
              this.goTo(this.index + (delta < 0 ? 1 : -1));
            } else {
              this.goTo(this.index);
            }
          }
          this.startAuto();
        };

        this.viewport.addEventListener('pointerup', end);
        this.viewport.addEventListener('pointercancel', end);

        // Tras arrastrar, el "click" de soltar no debe activar el botón ADD.
        this.viewport.addEventListener(
          'click',
          (event) => {
            if (!moved) return;
            event.preventDefault();
            event.stopPropagation();
            moved = false;
          },
          true
        );
      }

      disconnectedCallback() {
        this.stopAuto();
      }
    }
  );
}

/* ---------- Regalo automático al alcanzar el objetivo ---------- */

if (!customElements.get('ff-cart-gift')) {
  customElements.define(
    'ff-cart-gift',
    class FfCartGift extends HTMLElement {
      // Compartido entre instancias: evita dos peticiones a la vez si el
      // carrito se vuelve a pintar mientras una sigue en curso.
      static busy = false;

      connectedCallback() {
        const drawer = this.closest('cart-drawer');
        // Solo se actúa con el carrito abierto: si no, abrir la página ya
        // dispararía cambios sin que nadie haya tocado nada.
        if (!drawer || !drawer.classList.contains('active')) return;
        if (FfCartGift.busy) return;

        const unlocked = this.dataset.unlocked === 'true';
        const inCart = this.dataset.inCart === 'true';

        if (unlocked && !inCart) {
          this.addGift(drawer);
        } else if (!unlocked && inCart) {
          this.removeGift();
        }
      }

      addGift(drawer) {
        const variantId = this.dataset.variant;
        if (!variantId) return;

        FfCartGift.busy = true;
        fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) return; // el producto no se pudo agregar
            drawer.renderContents(data);
          })
          .catch(() => {})
          .finally(() => {
            FfCartGift.busy = false;
          });
      }

      removeGift() {
        const line = this.dataset.line;
        const items = document.querySelector('cart-drawer-items');
        if (!line || !items) return;

        FfCartGift.busy = true;
        items.updateQuantity(line, 0);
        setTimeout(() => {
          FfCartGift.busy = false;
        }, 1200);
      }
    }
  );
}

/* ---------- Theme Editor: mantener el carrito abierto ----------
   Al cambiar cualquier ajuste, Shopify vuelve a pintar la sección entera y el
   <cart-drawer> nuevo nace cerrado. Sin esto habría que reabrir el carrito a
   mano después de cada retoque, que es justo lo que se quiere evitar. */

if (window.Shopify && window.Shopify.designMode) {
  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    // Un frame de margen: el elemento debe estar ya definido y en el DOM.
    requestAnimationFrame(() => drawer.open());
  };

  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail?.sectionId !== 'cart-drawer') return;
    openCartDrawer();
  });

  // Al seleccionar un objetivo o una sugerencia en el panel lateral, se abre
  // el carrito para poder ver en vivo lo que se está editando.
  document.addEventListener('shopify:block:select', (event) => {
    if (!event.target?.closest?.('cart-drawer')) return;
    openCartDrawer();
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event.detail?.sectionId !== 'cart-drawer') return;
    openCartDrawer();
  });
}

/* Fuego & Fragancia — desplegables de variante en la tarjeta de
   recomendacion del carrito.

   Es un custom element y no un listener suelto a proposito: el panel del
   carrito se REPINTA entero en cada cambio (Section Rendering API), asi que
   cualquier listener enganchado a mano se perderia en el primer repintado.
   Un custom element se vuelve a arrancar solo cada vez que aparece. */

if (!customElements.get('ff-rec-variants')) {
  customElements.define(
    'ff-rec-variants',
    class FfRecVariants extends HTMLElement {
      connectedCallback() {
        try {
          this.variantes = JSON.parse(this.dataset.variants || '[]');
        } catch (e) {
          this.variantes = [];
        }

        /* El campo del id vive DENTRO del formulario (product-form revienta si
           no lo encuentra ahi) y los desplegables fuera, para que la rejilla
           de la tarjeta pueda colocarlos. Se enlazan por el id del form. */
        this.form = this.dataset.form ? document.getElementById(this.dataset.form) : null;
        this.campo = this.form && this.form.querySelector('[data-ff-rec-id]');
        this.selects = Array.from(this.querySelectorAll('select'));
        this.selects.forEach((s) => {
          s.addEventListener('change', () => this.resolver());
          this.montarBoton(s);
        });

        // Solo cuando el botón propio ya está puesto se esconde el <select>.
        // Si algo de arriba fallara, el desplegable nativo sigue ahí y la
        // tarjeta se puede usar igual.
        this.classList.add('is-enhanced');
        this.resolver();
      }

      disconnectedCallback() {
        this.cerrar();
      }

      /* ---------- Desplegable propio ----------
         La LISTA de un <select> la pinta el sistema operativo: en el móvil sale
         la rueda de Android o de iOS y no admite un solo color propio. Por eso
         el select se queda como fuente de verdad (lo leen el resolver y
         product-form) pero se esconde, y encima se dibuja un botón que abre un
         panel nuestro. */

      montarBoton(sel) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ff-rec-trigger';
        btn.setAttribute('aria-haspopup', 'listbox');
        btn.setAttribute('aria-expanded', 'false');

        const texto = document.createElement('span');
        texto.className = 'ff-rec-trigger__text';
        const flecha = document.createElement('span');
        flecha.className = 'ff-rec-trigger__caret';
        flecha.setAttribute('aria-hidden', 'true');
        btn.append(texto, flecha);

        const pintar = () => {
          const op = sel.options[sel.selectedIndex];
          texto.textContent = op ? op.textContent.trim() : '';
        };
        pintar();
        sel.addEventListener('change', pintar);

        btn.addEventListener('click', (event) => {
          event.stopPropagation();
          if (this.abierto === sel) {
            this.cerrar();
          } else {
            this.abrir(sel, btn);
          }
        });

        sel.insertAdjacentElement('afterend', btn);
      }

      abrir(sel, btn) {
        this.cerrar();
        this.abierto = sel;
        this.disparador = btn;
        btn.setAttribute('aria-expanded', 'true');

        const panel = document.createElement('div');
        panel.className = 'ff-rec-panel';
        panel.setAttribute('role', 'listbox');

        Array.from(sel.options).forEach((op, i) => {
          const fila = document.createElement('button');
          fila.type = 'button';
          fila.className = 'ff-rec-panel__opt' + (i === sel.selectedIndex ? ' is-active' : '');
          fila.setAttribute('role', 'option');
          fila.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
          fila.textContent = op.textContent.trim();
          fila.addEventListener('click', (event) => {
            event.stopPropagation();
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            this.cerrar();
          });
          panel.appendChild(fila);
        });

        /* El panel se cuelga de <body>, no de la tarjeta. Dentro no cabría:
           el carrusel de sugerencias lleva overflow:hidden y lo recortaría, y
           su pista lleva un transform, que hace que position:fixed se mida
           contra ella en vez de contra la ventana. */
        document.body.appendChild(panel);
        this.panel = panel;
        this.colocar();

        // Cualquier cosa que mueva el botón deja el panel colgado en un sitio
        // que ya no le corresponde: mejor cerrarlo.
        this.cerrarFuera = () => this.cerrar();
        this.cerrarTecla = (event) => {
          if (event.key === 'Escape') this.cerrar();
        };
        document.addEventListener('click', this.cerrarFuera);
        document.addEventListener('keydown', this.cerrarTecla);
        window.addEventListener('resize', this.cerrarFuera);
        window.addEventListener('scroll', this.cerrarFuera, true);
      }

      /* En móvil sube desde el borde inferior, que es donde llega el pulgar.
         En pantallas anchas cuelga del botón. */
      colocar() {
        const panel = this.panel;
        if (window.matchMedia('(max-width: 520px)').matches) {
          panel.classList.add('ff-rec-panel--hoja');
          return;
        }

        const caja = this.disparador.getBoundingClientRect();
        const alto = panel.offsetHeight;
        const cabeDebajo = window.innerHeight - caja.bottom > alto + 12;

        panel.style.left = `${caja.left}px`;
        panel.style.width = `${Math.max(caja.width, 140)}px`;
        panel.style.top = cabeDebajo ? `${caja.bottom + 4}px` : `${caja.top - alto - 4}px`;
      }

      cerrar() {
        if (this.panel) {
          this.panel.remove();
          this.panel = null;
        }
        if (this.disparador) this.disparador.setAttribute('aria-expanded', 'false');
        this.abierto = null;
        document.removeEventListener('click', this.cerrarFuera);
        document.removeEventListener('keydown', this.cerrarTecla);
        window.removeEventListener('resize', this.cerrarFuera);
        window.removeEventListener('scroll', this.cerrarFuera, true);
      }

      /* Junta lo elegido en los desplegables y escribe el id de la variante
         que coincide. Si esa combinacion no existe se desactiva el boton, que
         es mas honesto que mandar al carrito una variante equivocada. */
      resolver() {
        if (!this.campo) return;

        const elegidas = this.selects.map((s) => s.value);
        const v = this.variantes.find(
          (x) =>
            x.opts.length === elegidas.length &&
            x.opts.every((valor, i) => valor === elegidas[i])
        );

        const boton = this.form && this.form.querySelector('[name="add"]');
        if (!v || !v.ok) {
          this.campo.value = '';
          if (boton) boton.disabled = true;
          return;
        }
        this.campo.value = v.id;
        if (boton) boton.disabled = false;
      }
    }
  );
}
